import { getAllDocumentsAPI } from "../../apiRequests/documents/getAllDocumentsAPI";
import { AppThunk } from "../store";
import { setDocuments, setIsLoading } from "./documents-reducer";

export const getAllDocumentsThunk = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setIsLoading(true));
        const allDocuments = await getAllDocumentsAPI();
        dispatch(setDocuments(allDocuments));
    } catch (error) {
        console.log(error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
